import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import TasksExecsListByAuthUser from '../../../../../components/Tasks/TasksExecsLists/TasksExecsListByAuthUser';

class ArbitrationTasksList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reducerName: `arbitrationTasksList`,
      queryParamsStatic: {
        status: 7
      }
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <TasksExecsListByAuthUser
        reducerName={this.state.reducerName}
        queryParamsStatic={this.state.queryParamsStatic}
      />
    );
  }
}

export default withRouter(ArbitrationTasksList);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/ArbitrationTasksList/ArbitrationTasksList.js